// extracted by mini-css-extract-plugin
module.exports = {"upgradeBtn":"style_upgradeBtn__Eevux"};